import { observer } from 'mobx-react';
import { ChangeEvent, FC, useCallback, useMemo } from 'react';
import ColorsBlock from '../../../../containers/ColorsBlock/ColorsBlock';
import configWebStore from '../../stores';
import { IConfigWebColorRow } from '../../types';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';
import Textarea from '~/view/components/Controls/Textarea/Textarea';

const WebConfigColorsTab: FC = observer((): JSX.Element => {
  const { colors, focusField, isFocusFieldValue, colorsValidation, changeColors, setFocusField } = configWebStore;

  const colorsRows = useMemo((): IConfigWebColorRow[] => {
    return [
      { field: 'headerBackgroundFirstColor', title: localeStore.t('header_background_1') },
      { field: 'headerBackgroundSecondColor', title: localeStore.t('header_background_2') },
      { field: 'headerPlaneTextColor', title: 'header_plane_text_color' },
      { field: 'headerBackgroundSelectedColor', title: 'header_background_selected_color' },
      { field: 'headerBackgroundSelectedTextColor', title: 'header_background_selected_text_color' },
      { field: 'buttonsColor', title: 'highlight_buttons_color' },
      { field: 'buttonsTextColor', title: 'buttons_text_color' },
    ];
  }, []);

  const changeCss = useCallback((event: ChangeEvent<HTMLTextAreaElement>) => {
    changeColors({ css: event.target.value });
  }, []);

  return (
    <ColorsBlock
      rows={colorsRows}
      values={colors}
      focusField={focusField}
      focusFieldValue={isFocusFieldValue}
      changeColors={changeColors}
      setFocusField={setFocusField}
      submit={configWebStore.submit}
      validation={colorsValidation}
    >
      <div className="d-flex flex-column mt-4 gap-10">
        <p className="web-config-colors__css-title">CSS</p>
        <Textarea value={colors.css} onChange={changeCss} textAreaClassName="web-config-colors__css-text-area" />
      </div>
    </ColorsBlock>
  );
});

export default WebConfigColorsTab;
